/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Reasoning_Past_4Inputs */



/**
* | output |
* | --- |
* | "pieced it together" |
*
* @param {Chat_Summary_Reasoning_Past_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_reasoning_past_4 = /** @type {((inputs?: Chat_Summary_Reasoning_Past_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Reasoning_Past_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("es zusammengefügt")
	return /** @type {LocalizedString} */ ("pieced it together")
});